<template>
  <b-modal
    :id="modalId"
    :title="modalTitle"
    ok-title="Guardar"
    cancel-title="Cancelar"
    @ok="handleSubmit"
    @hidden="resetForm"
  >
    <b-form @submit.prevent="handleSubmit">
      <b-form-group label="Código de la Facultad">
        <b-form-input
          v-model="form.codigo"
          placeholder="Ej: ING"
          required
          maxlength="10"
        />
      </b-form-group>

      <b-form-group label="Nombre de la Facultad" class="mt-1">
        <b-form-input
          v-model="form.nombre"
          placeholder="Ej: Facultad de Ingeniería"
          required
          maxlength="200"
        />
      </b-form-group>

      <b-form-group label="Descripción" class="mt-1">
        <b-form-textarea
          v-model="form.descripcion"
          placeholder="Descripción de la facultad (opcional)"
          rows="3"
          maxlength="500"
        />
      </b-form-group>

      <b-form-group label="Estado" class="mt-1">
        <b-form-select
          v-model="form.estado"
          :options="statusOptions"
          required
        />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormInput, BFormSelect, BFormTextarea } from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
  },
  props: {
    facultyData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalId: 'faculty-modal',
      form: {
        facultadId: null,
        codigo: '',
        nombre: '',
        descripcion: '',
        estado: true,
      },
      statusOptions: [
        { text: 'Activo', value: true },
        { text: 'Inactivo', value: false }
      ],
    }
  },
  computed: {
    modalTitle() {
      return this.form.facultadId ? 'Editar Facultad' : 'Nueva Facultad'
    },
  },
  watch: {
    facultyData(newData) {
      if (newData) {
        this.form = { ...newData }
      } else {
        this.resetForm()
      }
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('submit', { ...this.form })
      this.$bvModal.hide(this.modalId)
    },
    resetForm() {
      this.form = {
        facultadId: null,
        codigo: '',
        nombre: '',
        descripcion: '',
        estado: true,
      }
    },
  },
}
</script>
